<template>
  <div>
    <div
      class="modal fade"
      id="account-details"
      tabindex="-1"
      aria-hidden="false"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-centered modal-simple modal-upgrade-plan"
      >
        <div v-if="visible" class="modal-content">
          <div class="modal-body pt-0">
            <button
              type="button"
              id="add-account-close"
              ref="add_account_close"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>

            <div class="text-center">
              <h2 class="mb-7">Account Details</h2>
            </div>

            <div class="row d-flex justify-content-center">
              <div class="col-12 col-lg-6 mb-8">
                <div class="card h-100">
                  <div class="card-header d-flex justify-content-center">
                    <div class="card-title mb-0">
                      <h5 class="mb-0">General Information</h5>
                    </div>
                  </div>
                  <div class="card-body mt-7">
                    <ul class="list-unstyled mb-0 ">
                      <li class="d-flex mb-6 align-items-center">
                        <div class="avatar flex-shrink-0 me-4">
                          <span class="avatar-initial rounded bg-label-primary"
                            ><i class="ti ti-user ti-lg"></i
                          ></span>
                        </div>
                        <div class="row w-100 align-items-center">
                          <div
                            class="col-sm-5 col-lg-12 col-xxl-5 mb-1 mb-sm-0 mb-lg-1 mb-xxl-0"
                          >
                            <h6 class="mb-0">Full Name:</h6>
                          </div>
                          <div
                            class="col-sm-7 col-lg-12 col-xxl-7 d-flex justify-content-xxl-end"
                          >
                            <div class="badge bg-label-secondary">
                              {{
                                selectedAccount.first_name +
                                  " " +
                                  selectedAccount.last_name
                              }}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="d-flex mb-6 align-items-center">
                        <div class="avatar flex-shrink-0 me-4">
                          <span class="avatar-initial rounded bg-label-primary"
                            ><i class="ti ti-mail ti-lg"></i
                          ></span>
                        </div>
                        <div class="row w-100 align-items-center">
                          <div
                            class="col-sm-5 col-lg-12 col-xxl-5 mb-1 mb-sm-0 mb-lg-1 mb-xxl-0"
                          >
                            <h6 class="mb-0">Email:</h6>
                          </div>
                          <div
                            class="col-sm-7 col-lg-12 col-xxl-7 d-flex justify-content-xxl-end"
                          >
                            <div class="badge bg-label-secondary">
                              {{ selectedAccount.email }}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="d-flex mb-6 align-items-center">
                        <div class="avatar flex-shrink-0 me-4">
                          <span class="avatar-initial rounded bg-label-primary"
                            ><i class="ti ti-phone ti-lg"></i
                          ></span>
                        </div>
                        <div class="row w-100 align-items-center">
                          <div
                            class="col-sm-6 col-lg-12 col-xxl-6 mb-1 mb-sm-0 mb-lg-1 mb-xxl-0"
                          >
                            <h6 class="mb-0">Mobile Phone Number:</h6>
                          </div>
                          <div
                            class="col-sm-6 col-lg-12 col-xxl-6 d-flex justify-content-xxl-end"
                          >
                            <div class="badge bg-label-secondary">
                              {{ selectedAccount.phone }}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="d-flex mb-6 align-items-center">
                        <div class="avatar flex-shrink-0 me-4">
                          <span class="avatar-initial rounded bg-label-primary"
                            ><i class="ti ti-at ti-lg"></i
                          ></span>
                        </div>
                        <div class="row w-100 align-items-center">
                          <div
                            class="col-sm-5 col-lg-12 col-xxl-5 mb-1 mb-sm-0 mb-lg-1 mb-xxl-0"
                          >
                            <h6 class="mb-0">Username:</h6>
                          </div>
                          <div
                            class="col-sm-7 col-lg-12 col-xxl-7 d-flex justify-content-xxl-end"
                          >
                            <div class="badge bg-label-secondary">
                              {{ selectedAccount.username }}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="d-flex mb-6 align-items-center">
                        <div class="avatar flex-shrink-0 me-4">
                          <span class="avatar-initial rounded bg-label-primary"
                            ><i class="ti ti-lock ti-lg"></i
                          ></span>
                        </div>
                        <div class="row w-100 align-items-center">
                          <div
                            class="col-sm-5 col-lg-12 col-xxl-5 mb-1 mb-sm-0 mb-lg-1 mb-xxl-0"
                          >
                            <h6 class="mb-0">Password:</h6>
                          </div>
                          <div
                            class="col-sm-7 col-lg-12 col-xxl-7 d-flex justify-content-xxl-end"
                          >
                            <div class="badge bg-label-secondary">
                              {{ selectedAccount.password }}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="d-flex mb-6 align-items-center">
                        <div class="avatar flex-shrink-0 me-4">
                          <span class="avatar-initial rounded bg-label-primary"
                            ><i class="ti ti-versions ti-lg"></i
                          ></span>
                        </div>
                        <div class="row w-100 align-items-center">
                          <div
                            class="col-sm-5 col-lg-12 col-xxl-5 mb-1 mb-sm-0 mb-lg-1 mb-xxl-0"
                          >
                            <h6 class="mb-0">Allowed Sessions:</h6>
                          </div>
                          <div
                            class="col-sm-7 col-lg-12 col-xxl-7 d-flex justify-content-xxl-end"
                          >
                            <div class="badge bg-label-secondary">
                              {{ selectedAccount.allowed_sessions }} Session
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="d-flex mb-6 align-items-center">
                        <div class="avatar flex-shrink-0 me-4">
                          <span class="avatar-initial rounded bg-label-primary"
                            ><i class="ti ti-currency-dollar ti-lg"></i
                          ></span>
                        </div>
                        <div class="row w-100 align-items-center">
                          <div
                            class="col-sm-5 col-lg-12 col-xxl-5 mb-1 mb-sm-0 mb-lg-1 mb-xxl-0"
                          >
                            <h6 class="mb-0">Credits:</h6>
                          </div>
                          <div
                            class="col-sm-7 col-lg-12 col-xxl-7 d-flex justify-content-xxl-end"
                          >
                            <div class="badge bg-label-secondary">
                              {{ selectedAccount.money }} $
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="d-flex align-items-center">
                        <div class="avatar flex-shrink-0 me-4">
                          <span class="avatar-initial rounded bg-label-primary"
                            ><i class="ti ti-moneybag ti-lg"></i
                          ></span>
                        </div>
                        <div class="row w-100 align-items-center">
                          <div
                            class="col-sm-5 col-lg-12 col-xxl-5 mb-1 mb-sm-0 mb-lg-1 mb-xxl-0"
                          >
                            <h6 class="mb-0">Debts:</h6>
                          </div>
                          <div
                            class="col-sm-7 col-lg-12 col-xxl-7 d-flex justify-content-xxl-end"
                          >
                            <div class="badge bg-label-secondary">
                              {{ selectedAccount.debt }} $
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-6 mb-8">
                <div class="card h-100">
                  <div class="card-header d-flex justify-content-center">
                    <div class="card-title mb-0">
                      <h5 class="mb-0">Details</h5>
                    </div>
                  </div>
                  <div class="card-body mt-7">
                    <ul class="list-unstyled mb-0 ">
                      <li class="d-flex mb-6 align-items-center">
                        <div class="avatar flex-shrink-0 me-4">
                          <span class="avatar-initial rounded bg-label-primary"
                            ><i class="ti ti-brand-databricks ti-lg"></i
                          ></span>
                        </div>
                        <div class="row w-100 align-items-center">
                          <div
                            class="col-sm-5 col-lg-12 col-xxl-5 mb-1 mb-sm-0 mb-lg-1 mb-xxl-0"
                          >
                            <h6 class="mb-0">Profile:</h6>
                          </div>
                          <div
                            class="col-sm-7 col-lg-12 col-xxl-7 d-flex justify-content-xxl-end"
                          >
                            <div class="badge bg-label-secondary">
                              {{ selectedAccount.profile.name }}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="d-flex mb-6 align-items-center">
                        <div class="avatar flex-shrink-0 me-4">
                          <span class="avatar-initial rounded bg-label-primary"
                            ><i class="ti ti-calendar-off ti-lg"></i
                          ></span>
                        </div>
                        <div class="row w-100 align-items-center">
                          <div
                            class="col-sm-5 col-lg-12 col-xxl-5 mb-1 mb-sm-0 mb-lg-1 mb-xxl-0"
                          >
                            <h6 class="mb-0">Expires At:</h6>
                          </div>
                          <div
                            class="col-sm-7 col-lg-12 col-xxl-7 d-flex justify-content-xxl-end"
                          >
                            <div class="badge bg-label-secondary">
                              {{ selectedAccount.expires_at }}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="d-flex mb-6 align-items-center">
                        <div class="avatar flex-shrink-0 me-4">
                          <span class="avatar-initial rounded bg-label-primary"
                            ><i class="ti ti-calendar-plus ti-lg"></i
                          ></span>
                        </div>
                        <div class="row w-100 align-items-center">
                          <div
                            class="col-sm-5 col-lg-12 col-xxl-5 mb-1 mb-sm-0 mb-lg-1 mb-xxl-0"
                          >
                            <h6 class="mb-0">Created At:</h6>
                          </div>
                          <div
                            class="col-sm-7 col-lg-12 col-xxl-7 d-flex justify-content-xxl-end"
                          >
                            <div class="badge bg-label-secondary">
                              {{ selectedAccount.created_at }}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="d-flex mb-6 align-items-center">
                        <div class="avatar flex-shrink-0 me-4">
                          <span class="avatar-initial rounded bg-label-primary"
                            ><i class="ti ti-calendar-cog ti-lg"></i
                          ></span>
                        </div>
                        <div class="row w-100 align-items-center">
                          <div
                            class="col-sm-5 col-lg-12 col-xxl-5 mb-1 mb-sm-0 mb-lg-1 mb-xxl-0"
                          >
                            <h6 class="mb-0">Last Edit:</h6>
                          </div>
                          <div
                            class="col-sm-7 col-lg-12 col-xxl-7 d-flex justify-content-xxl-end"
                          >
                            <div class="badge bg-label-secondary">
                              {{ selectedAccount.updated_at }}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="d-flex mb-6 align-items-center">
                        <div class="avatar flex-shrink-0 me-4">
                          <span class="avatar-initial rounded bg-label-primary"
                            ><i class="ti ti-devices-check ti-lg"></i
                          ></span>
                        </div>
                        <div class="row w-100 align-items-center">
                          <div
                            class="col-sm-7 col-lg-12 col-xxl-7 mb-1 mb-sm-0 mb-lg-1 mb-xxl-0"
                          >
                            <h6 class="mb-0">Connected Devices Count:</h6>
                          </div>
                          <div
                            class="col-sm-5 col-lg-12 col-xxl-5 d-flex justify-content-xxl-end"
                          >
                            <div class="badge bg-label-secondary">
                              {{
                                selectedAccount.active_sessions
                                  ? selectedAccount.active_sessions.length
                                  : 0
                              }}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="d-flex align-items-center">
                        <div class="avatar flex-shrink-0 me-4">
                          <span class="avatar-initial rounded bg-label-primary"
                            ><i class="ti ti-calendar-bolt ti-lg"></i
                          ></span>
                        </div>
                        <div class="row w-100 align-items-center">
                          <div
                            class="col-sm-5 col-lg-12 col-xxl-5 mb-1 mb-sm-0 mb-lg-1 mb-xxl-0"
                          >
                            <h6 class="mb-0">Last Time Online:</h6>
                          </div>
                          <div
                            class="col-sm-7 col-lg-12 col-xxl-7 d-flex justify-content-xxl-end"
                          >
                            <div class="badge bg-label-secondary">
                              {{ selectedAccount.last_seen }}
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class=" grid grid-cols-2  lg:grid-cols-3 xl:grid-cols-4 gap-3">
              <button type="button" class="btn btn-primary">
                <span class="ti-xs ti ti-edit me-2"></span>Edit
              </button>
              <button type="button" class="btn btn-primary">
                <span class="ti-xs ti ti-eye me-2"></span>View Sessions
              </button>
              <button type="button" class="btn btn-primary">
                <span class="ti-xs ti ti-receipt-2 me-2"></span>View invoices
              </button>
              <button type="button" class="btn btn-primary">
                <span class="ti-xs ti ti-clock-play me-2"></span>Add 2 days wait
              </button>
              <button type="button" class="btn btn-primary">
                <span class="ti-xs ti ti-browser-check me-2"></span>Activate for
                2 days free
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="showRenew"
              >
                <span class="ti-xs ti ti-exchange me-2"></span>Renew/ Change
                Profile
              </button>
              <button type="button" class="btn btn-primary">
                <span class="ti-xs ti ti-database-edit me-2"></span>Edit Credits
              </button>
              <button type="button" class="btn btn-primary">
                <span class="ti-xs ti ti-transfer-vertical me-2"></span
                >Temporary Speed
              </button>
              <button type="button" class="btn btn-primary">
                <span class="ti-xs ti ti-spaces me-2"></span>Clear Sessions
              </button>
              <button type="button" class="btn btn-primary">
                <span class="ti-xs ti ti-network-off me-2"></span>Disconnect
              </button>
              <button type="button" class="btn btn-primary">
                <span class="ti-xs ti ti-world-check me-2"></span>Enable
              </button>
              <button type="button" class="btn btn-danger">
                <span class="ti-xs ti ti-trash me-2"></span>Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import ExpiredWindow from "./ExpiredWindow.vue";
import { hasPrivilege } from "../../global_constants.js";
export default {
  components: {
    ExpiredWindow,
  },
  name: "AccountDetails",
  props: ["selectedAccount", "visible"],
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  methods: {
    showRenew() {
      this.$refs.add_account_close.click();
      this.$emit("showRenewProfile");
    },
  },
};
</script>
<style>
.modal2 {
  --bs-modal-zindex: 1090;
  --bs-modal-width: 35rem;
  --bs-modal-padding: 1.5rem;
  --bs-modal-margin: 1.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: #2f3349;
  --bs-modal-border-color: #44485e;
  --bs-modal-border-width: 0px;
  --bs-modal-border-radius: 0.5rem;
  --bs-modal-box-shadow: 0 0.25rem 1.125rem 0 rgba(19, 17, 32, 0.22);
  --bs-modal-inner-border-radius: calc(0.5rem - 0px);
  --bs-modal-header-padding-x: 0rem;
  --bs-modal-header-padding-y: 1.5rem;
  --bs-modal-header-padding: 1.5rem 1.5rem 0rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: 0px;
  --bs-modal-title-line-height: 1.375;
  --bs-modal-footer-gap: 1rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: 0px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}
</style>
